import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import TablePagination from "@material-ui/core/TablePagination";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import PresentToAll from "@material-ui/icons/PresentToAll";
import { useSelector, useDispatch } from "react-redux";
import {
  getClassData,
  getFacultyClassData,
  clearErrorStatusCode,
  clearErrorMessage,
  clearClassData,
  getTermData,
  updateParmsForClass,
  setErrorMessage,
  getAttendanceData,
} from "../../../../reduxSlices/classesSlice";

import { getOptionList } from "../../../../reduxSlices/applicationSlice";
import { isObjectEmpty } from "../../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import Backdrop from "../../../Backdrop";
import Aux from "../../../../hoc/Auxilliary";
import MessageIndicator from "../../../SnackBar";
import localizedStrings from "../../../../utils/localize";
import Attendance from "../Attendance";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
});

function PageConatiner(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [termsData, setTerms] = useState("");
  const [filterTermsData, setfilterTermsData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [status, setStatus] = useState("");
  const [studentId, setStudentId] = useState(undefined);
  const [displayMessage,setDisplayMessage]=useState('')
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [modalTableMapData, setModalTableMapData] = useState([]);

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const [tableMapData, setTableMapData] = useState([]);

  const classData = useSelector((state) => state.classData.classData);
  const terms = useSelector((state) => state.classData.terms);
  const dataFetchingStatus = useSelector(
    (state) => state.classData.dataFetchingStatus
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus
  );
  const optionList = useSelector((state) => state.applicationData.optionList);

  const errorMessage = useSelector((state) => state.classData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.classData.errorStatusCode
  );
  useEffect(() => {
    dispatch(
      getFacultyClassData(window.localStorage.getItem("x-auth-contactId"))
    );
    dispatch(getTermData());
  }, [dispatch]);



  useEffect(() => {
    if (applicantStatus.ses_applicantstatus) {
      setStudentId(applicantStatus.ses_applicantstatus.ses_studentid);
    }
  }, [applicantStatus]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };

  const handleUpdate = (e, sessionId) => {
    e.preventDefault();
    dispatch(updateParmsForClass({ sessionId }));
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearClassData());
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const compareDate = (date) => {
    var currentDate = new Date();
    var givenDate = new Date(date);

    if (givenDate.getTime() > currentDate.getTime()) return true;
    return false;
  };
  const attendanceData = useSelector((state) => state.classData.attendance);

  useEffect(() => {
    if (attendanceData.length > 0) {
      const attendances = [...attendanceData];
      setModalTableMapData(
        attendances.sort(
          (item1, item2) => new Date(item1.ses_date) - new Date(item2.ses_date)
        )
      );
    }
  }, [attendanceData]);

  const handleModalOpen = (classId) => {
    if (studentId && classId) {
      dispatch(getAttendanceData({ classId, studentId }));

      setOpenModal(true);
    }
  };

  const handleModalClose = () => {
    setModalTableMapData([]);
    setOpenModal(false);
  };

  useEffect(() => {
    if (!isObjectEmpty(classData)) setTableMapData(classData.data);
  }, [classData]);

  function uniqBy(a, key) {
    var seen = {};
    return a.filter(function (item) {
      var k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }


  const funcOptionList = (status) => {
    var value;
    if (optionList?.length != 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
      });
    }
    return value;
  };

  useEffect(() => {
    let entity = "ses_class";
    let attributename = "ses_classstatus";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    var filterTerms = [];
    if (classData?.data?.length != 0) {
      classData?.data?.map((element) => {
        terms?.data?.map((term) => {
          if (element.ses_termname === term.ses_termname) {
            filterTerms.push(term);
          }
        });
      });
    }
    let newfilter = filterTerms;
    newfilter = uniqBy(filterTerms, JSON.stringify);
    setfilterTermsData(newfilter);
  }, [terms, classData]);

  let tableData = "";
  let termData = "";
  if (!isObjectEmpty(classData.data)) {
    if (classData.data) {
      if (Array.isArray(classData.data)) {
        tableData =
          tableMapData.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        {element.ses_class}
                      </StyledTableCell>
                      <StyledTableCell>{element.ses_classname}</StyledTableCell>
                      <StyledTableCell>{element.ses_section}</StyledTableCell>
                      <StyledTableCell>
                        {element.ses_creditsavailable}
                      </StyledTableCell>
                      <StyledTableCell>
                        {funcOptionList(element.ses_classstatus)}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_grade === true ? "Grade" : ""}
                      </StyledTableCell>

                      <StyledTableCell>{element.ses_termname}</StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;
        termData = filterTermsData.map((element, index) => (
          <MenuItem value={element.ses_termname} key={index}>
            {element.ses_termname}
          </MenuItem>
        ));
      }
    }
  }

  const handleChange = (event) => {
    const copyTableMapData = [...classData.data];
    if (event.target.value.length === 0) {
      setTableMapData(copyTableMapData);
    } else {
      let copyData = copyTableMapData.filter(
        (element) => element.ses_termname === event.target.value
      );
      setTableMapData(copyData);
    }

    setTerms(event.target.value);
  };
  useEffect(() => {
    if (error.message === 'No data found!') {
      setDisplayMessage(localizedStrings.general.classerrorMessage);
    }
    else if (error.message === 'No attendance record available') {
      setDisplayMessage(localizedStrings.general.noattendanceMessage);
    }
    else if (error.message === 'Invalid token') {
      setDisplayMessage(localizedStrings.general.invalidToken);
    }
    else if (error.message === 'Invalid token or you are missing header token') {
      setDisplayMessage(localizedStrings.general.invalidTokenandheader);
    }
    else if (error.message === 'Something Went Wrong') {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    }
    else{
      setDisplayMessage(error.message);
    }
  }, [error]);
  
   // Custom label for the "of" keyword in TablePagination
   const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };
  
  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Attendance
        open={openModal}
        tableMapData={modalTableMapData}
        onHandleClose={handleModalClose}
      />
      <TableContainer
        component={Paper}
        style={{ minHeight: "40vh", marginBottom: "10px" }}
      >
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>{localizedStrings.facultyAndStuff.class.class}</StyledTableCell>
              <StyledTableCell>{localizedStrings.facultyAndStuff.class.classname}</StyledTableCell>
              <StyledTableCell>Section</StyledTableCell>
              <StyledTableCell>{localizedStrings.facultyAndStuff.class.credits}</StyledTableCell>
              <StyledTableCell>{localizedStrings.facultyAndStuff.class.status}</StyledTableCell>
              <StyledTableCell>{localizedStrings.facultyAndStuff.class.gradeoption}</StyledTableCell>

              <StyledTableCell>
                <div className={classes.TableControl}>
                  <FormControl className={classes.formControl}>
                    <Select
                      value={termsData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                    >
                      <MenuItem value="">
                        {localizedStrings.students.classes.table.allTerms}{" "}
                      </MenuItem>
                      {termData}
                    </Select>
                  </FormControl>
                </div>
              </StyledTableCell>
        
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={tableMapData.length > 0 ? tableMapData.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={<span style={{textTransform:"none"}}>{localizedStrings.rows.rowsperpage}</span>}
          labelDisplayedRows={customLabelDisplayedRows}
        />
      </TableContainer>
    </Aux>
  );
}

export default withRouter(PageConatiner);
